import { default as axios } from '../utils/axios.instances' // eslint-disable-line

const axiosInstance = axios.getSTAxios() // eslint-disable-line

export default {

  async loadCampaign (id) {
    return Promise.all([this.loadCampaignConsumerOptions(id), this.loadCampaignScmFields(id), this.loadCampaignInfos(id)]).then((data) => {
      return { consumerOptions: data[0], scmFields: data[1], campaignData: data[2] }
    })
  },

  async loadCampaigns () {
    return new Promise((resolve, reject) => {
      axiosInstance.get('/campaigns/?limit=1&offset=0&is_archived=false').then((res) => {
        resolve(res.data.count)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  loadCampaignInfos (id) {
    return new Promise((resolve, reject) => {
      axiosInstance.get(`/campaigns/${id}/`).then((res) => {
        resolve(res.data)
      })
    })
  },

  loadCampaignConsumerOptions (id) {
    return new Promise((resolve, reject) => {
      axiosInstance.get(`/campaigns/${id}/consumer/`).then((res) => {
        resolve(res.data)
      })
    })
  },

  loadCampaignScmFields (id) {
    return new Promise((resolve, reject) => {
      axiosInstance.get(`/campaigns/${id}/scm-fields/`).then((res) => {
        resolve(res.data)
      })
    })
  },

  async updateRedirectUrl (id, redirectUrl, isEnabled) {
    return new Promise((resolve, reject) => {
      axiosInstance.patch(`/campaigns/${id}/consumer/`, { consumer_url: redirectUrl, is_enabled: isEnabled }).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async updateCampaignSettings (id, redirectUrl, json) {
    return new Promise((resolve, reject) => {
      axiosInstance.patch(`/campaigns/${id}/consumer/`, { consumer_url: redirectUrl, stc_config: json }).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async updateCampaignOptions (id, json) {
    return new Promise((resolve, reject) => {
      axiosInstance.patch(`/campaigns/${id}/consumer/`, { stc_config: json }).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async loadConfig (id) {
    return new Promise((resolve, reject) => {
      axiosInstance.get(`/stc/configs/${id}/`).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async updateRemoteConfig (options) {
    console.log('OPTIONS TO UDPATE', options)
    return new Promise((resolve, reject) => {
      axiosInstance.patch(`/stc/configs/${options.id}/`, { config_json: options.config }).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  }

  // Load campaign/:id/consumer/
  // Load campaign/:id/scm-fields/

}
